import api from './api';

export const getNotifications = async () => {
  return api.get('/user_notifications');
}